import React from 'react';
// import superagent from 'superagent';
// import Signup from './signup';
import { inject, observer } from 'mobx-react';
import '../../../../styles/login.css';
// import PropTypes from 'prop-types';
import Modal from 'react-bulma-components/lib/components/modal';
// import Image from 'react-bulma-components/lib/components/image';
import Button from 'react-bulma-components/lib/components/button';
import Section from 'react-bulma-components/lib/components/section';
import { withRouter, Link } from 'react-router-dom';
import { validateIfInputHasSpaces } from '../../../../helpers/validationChecks'
// import UserStore from '../../stores/userStore';
// import LandingPage from './landingPage';
import { Label } from 'react-bulma-components/lib/components/form';
// let _login = false
import { Redirect } from 'react-router-dom';
// import SocialButton from './socialLogin'
// const imagesPath = {
//     unchecked: require('../../../assets/unchecked.png'),
//     checked: require('../../../assets/checked.png')
// }

@inject('authStore', 'userStore', 'navigatorStore')
@withRouter
@observer
export default class changePWD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: "",
            cpassword: ""
        }
    }
    onValuChangedText(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }
    onSaveDataForPassword(e) {
        // debugger;
        e.preventDefault();
         
        if(!this.state.password){
            this.props.navigatorStore.openErrorModal("New password must not be blank")
            return;
           }
        if (this.state.password.length < 6) {
            this.props.navigatorStore.openErrorModal("Password must have a minimum of 6 characters")
            return;
        }
        if (!validateIfInputHasSpaces(this.state.password)) { this.props.navigatorStore.openErrorModal("Password must not contain any space"); return; }
           if(!this.state.cpassword){
               this.props.navigatorStore.openErrorModal("Confirm password must not be blank")
               return;
           }
           if(this.state.cpassword != this.state.password){
               this.props.navigatorStore.openErrorModal("Passwords do not match")
               return;
           }
        if (this.state.password == this.state.cpassword && this.state.password.length >= 6 && validateIfInputHasSpaces(this.state.password)) {
            // console.log("[this is email and token]",

                // this.props.authStore.emailForPasswordChange,
                //     this.props.authStore.tokenForPasswordChange, 
                //     this.state.password
            // )
           
            var formData = new FormData()
            formData.append('email', this.props.authStore.emailForPasswordChange)
            formData.append('new_password', this.state.password);
            this.props.authStore.changePasswordSecurity(formData, this.props.authStore.tokenForPasswordChange)
                .then((res) => {
                    // console.log(res)
                    this.close();
                    this.props.navigatorStore.openErrorModal("Your password was successfully changed, please sign in again", false, null, true)
                    this.props.navigatorStore.openSignInModal();
                })
        }
      

    }
    close() {
        this.props.navigatorStore.closeChangePasswordForSecurity()
    }
    render() {
        return (
            <Modal show={this.props.navigatorStore.changePasswordForSecurity} onClose={this.close.bind(this)}

            >
                {/* {this.props.children} */}
                <Modal.Content>
                    <Section style={{ backgroundColor: 'white', padding: "none" }} className="mymodal">
                        <form className="myform" >
                            <div style={{ textAlign: "left" }} className="log-in">Update password
                            <img onClick={this.close.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../../../assets/cross_icon_for_close.png')}></img>
                            </div>
                            <div className="ruling-forgot-password-section"></div>

                            <p className="label label-text" style={{ fontWeight: "400", fontSize: "18px" }} >
                                Your security matters to us! <br /> We have updated our password policy.</p>
                            <Label className="mb-15">
                                <p className="label label-text">NEW PASSWORD</p>
                                <input className="input-rectangle" type="password" name="password" placeholder="New password" onChange={this.onValuChangedText.bind(this)} />
                            </Label>
                            <Label className="mb-15">
                                <p className="label label-text">CONFIRM PASSWORD</p>
                                <input className="input-rectangle" type="password" name="cpassword" placeholder="Confirm password" onChange={this.onValuChangedText.bind(this)} />
                            </Label>
                            <div className="remember-me-and-login-section" >

                                <div style={{
                                    flex: "1",

                                }} >
                                    <Button className="button-link-login" onClick={this.onSaveDataForPassword.bind(this)} style={{ backgroundColor: "#BEA57C", borderRadius: "unset", marginRight: "10px" }} ><p className="button-name-login">LOG IN</p></Button></div>

                            </div>


                        </form>
                    </Section>
                </Modal.Content>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/resetPassword/changePWDSecurity.js